import { Footprint } from "src/components/sidebar/contents/overview/Footprint";
import { CustomLink } from "../types";
import {
  EmergencyStopSub,
  InstalSwitchSub,
  StystemStatusSub,
  SystemStatus,
} from "src/components/sidebar/contents/overview/System-status";
import { ValidationRegulatorySupport } from "src/components/sidebar/contents/overview/Validation-regulatory-support";
import {
  Scalabilty,
  SubHotspot_1_2,
  SubHotspot_1_4,
  SubHotspot_3_8,
} from "src/components/sidebar/contents/flexibility/Scalabilty";
import { HollowFiberCartridges } from "src/components/sidebar/contents/flexibility/Hallow-fiber-cartridges";
import { FlatSheetCassettes } from "src/components/sidebar/contents/flexibility/Flat-sheet-cassettes";
import {
  BagKart,
  ExternalMixer,
  Mixing,
} from "src/components/sidebar/contents/flexibility/Mixing";
import {
  Administration,
  Evaluation,
  MethodEditor,
  SystemControl,
  Unicorn,
  UnicornSubhotspot,
} from "src/components/sidebar/contents/automation/Unicorn";
import { OpcUa } from "src/components/sidebar/contents/automation/Opc_ua";
import {
  FlowPath,
  Retentate_conent,
} from "src/components/sidebar/contents/process-control/Flow-path";
import {
  Pumps,
  Pumps_1,
  Pumps_2,
  Pumps_3,
} from "src/components/sidebar/contents/process-control/Pumps";
import {
  ConductivieySub,
  FlowMeterSub,
  PhSensorSub,
  PressureSub,
  Sensors,
  UvSensorSub,
} from "src/components/sidebar/contents/process-control/Sensors";

export const links: CustomLink[] = [
  {
    id: "1",
    text: "Overview",
    title: "Overview",
    hasSublinks: true,
    subLinks: [
      {
        id: "1-1",
        text: "Footprint",
        title: "Footprint",
        sidebar: { Content: Footprint },
        annotations: ["meassure"],
        staticFrameWithHotspot: [
          {
            annotation: "meassure",
            frame: 11.83,
          },
        ],
        subHotspots: [
          {
            name: "Footprint",
            annotation: "meassure",
            frame: 11.83,
          },
          {
            name: "Bagkart",
            annotation: "meas_BAG",
            frame: 10.33,
          },
          {
            name: "Fluxkart",
            annotation: "meas_FLUX",
            frame: 10.33,
          },
        ],
      },
      {
        id: "1-2",
        text: "System status",
        title: "System status",
        sidebar: { Content: SystemStatus },
        annotations: ["sys_stat"],
        staticFrameWithHotspot: [
          {
            annotation: "sys_stat",
            name: "System status",
            frame: 0.1,
          },
        ],
        subHotspots: [
          {
            annotation: "sys_stat",
            name: "System status",
            frame: 0.1,
          },
          {
            name: "Install switch",
            frame: 0.1,
            annotation: "btn_InstRunTest",
            content: { Block: InstalSwitchSub, align: "top" },
          },
          {
            name: "Status panel",
            frame: 0.1,
            annotation: "btn_PowrRunCont",
            content: { Block: StystemStatusSub, align: "top" },
          },
          {
            name: "Emergency STOP",
            frame: 0.1,
            annotation: "btn_EmrStop",
            content: { Block: EmergencyStopSub, align: "top" },
          },
        ],
      },
      {
        id: "1-3",
        text: "Validation and regulatory",
        title: "Validation and regulatory support",
        sidebar: { Content: ValidationRegulatorySupport },
        annotations: ["START"],
      },
    ],
  },
  {
    id: "2",
    text: "Flexibility",
    title: "Flexibility",
    hasSublinks: true,
    subLinks: [
      {
        id: "2-1",
        text: "Scalability",
        title: "Scalability",
        sidebar: { Content: Scalabilty },
        annotations: ["pose_A"],
        staticFrameWithHotspot: [
          {
            annotation: "pose_A",
            frame: 10.83,
          },
        ],
        subHotspots: [
          {
            annotation: "pose_A",
            frame: 10.83,
            name: '1/2" Flowkit',
            content: {
              Block: SubHotspot_1_2,
            },
          },
          {
            annotation: "pose_B",
            frame: 21.17,
            name: '1/4" Flowkit',
            content: {
              Block: SubHotspot_1_4,
            },
          },
        ],
      },
      {
        id: "2-2",
        text: "Hollow fiber cartridges",
        title: "Hollow fiber cartridges",
        sidebar: { Content: HollowFiberCartridges },
        annotations: ["filter_A"],
        staticFrameWithHotspot: [
          {
            annotation: "filter_A",
            frame: 15.5,
          },
        ],
        subHotspots: [
          {
            annotation: "filter_A",
            frame: 15.5,
            name: "1 cartridge",
          },
          {
            annotation: "filter_B",
            frame: 16,
            name: "2 cartridges",
          },
          {
            annotation: "filter_A",
            frame: 19.17,
            name: "Cartridge connected",
          },
        ],
      },
      {
        id: "2-3",
        text: "Flat sheet cassettes",
        title: "Flat sheet cassettes",
        sidebar: { Content: FlatSheetCassettes },
        annotations: ["kart_FLUX"],
        staticFrameWithHotspot: [
          {
            annotation: "kart_FLUX",
            frame: 10.83,
          },
        ],
      },
      {
        id: "2-4",
        text: "Mixing",
        title: "Mixing",
        sidebar: { Content: Mixing },
        annotations: ["START"],
        staticFrameWithHotspot: [
          {
            annotation: "START",
            frame: 10.83,
          },
        ],
        subHotspots: [
          {
            annotation: "START",
            frame: 10.83,
            name: "Mixing",
          },
          {
            annotation: "kart_BAG",
            frame: 10.83,
            name: "BagKart",
            content: {
              Block: BagKart,
            },
          },
          {
            annotation: "ext_MIX_XDUO",
            frame: 11.33,
            name: "External Mixer",
            content: {
              Block: ExternalMixer,
            },
          },
        ],
      },
    ],
  },
  {
    id: "3",
    text: "Automation",
    title: "Automation",
    animationSequences: [],
    hasSublinks: true,
    subLinks: [
      {
        id: "3-1",
        text: "UNICORN™",
        title: "UNICORN™",
        sidebar: { Content: Unicorn },
        annotations: ["pose_B"],
        staticFrameWithHotspot: [
          {
            annotation: "pose_B",
            frame: 0.1,
          },
        ],
        subHotspots: [
          {
            name: "UNICORN™",
            frame: 0.1,
            annotation: "pose_B",
            content: {
              Block: UnicornSubhotspot,
              align: "top",
            },
          },
          {
            name: "Method Editor",
            frame: 19.66,
            annotation: "laptop_A",
            content: {
              Block: MethodEditor,
              align: "top",
            },
          },
          {
            name: "System Control",
            frame: 20,
            annotation: "laptop_B",
            content: {
              Block: SystemControl,
              align: "top",
            },
          },
          {
            name: "Evaluation",
            frame: 20.33,
            annotation: "laptop_C",
            content: {
              Block: Evaluation,
              align: "top",
            },
          },
          {
            name: "Administration",
            frame: 20.66,
            annotation: "laptop_D",
            content: {
              Block: Administration,
              align: "top",
            },
          },
        ],
      },
      {
        id: "3-2",
        text: "OPC UA and DCS",
        title: "OPC UA and DCS",
        sidebar: { Content: OpcUa },
        annotations: ["pose_A"],
        staticFrameWithHotspot: [
          {
            annotation: "pose_A",
            frame: 0.1,
          },
        ],
      },
    ],
  },
  {
    id: "4",
    text: "Process control",
    title: "Process control",
    animationSequences: [],
    hasSublinks: true,
    subLinks: [
      {
        id: "4-1",
        text: "Flow path",
        title: "Flow path",
        sidebar: { Content: FlowPath },
        annotations: ["FlowChart_A"],
        animations: ["Scene"],
        animationSequences: [[0.33, 2]],
        subHotspots: [
          {
            animations: ["Scene"],
            animationSequences: [[0.33, 2]],
            annotation: "FlowChart_A",
            name: "Fold-out",
          },
          {
            annotation: "FlowChart_B",
            frame: 2.5,
            name: "TFF applications",
            content: {
              Block: Retentate_conent,
            },
          },
          {
            annotation: "FlowChart_B",
            frame: 3,
            name: "NFF applications",
          },
        ],
      },
      {
        id: "4-2",
        text: "Pumps",
        title: "Pumps",
        sidebar: { Content: Pumps },
        annotations: ["pose_C"],
        staticFrameWithHotspot: [
          {
            annotation: "pose_C",
            frame: 0.1,
          },
        ],
        subHotspots: [
          {
            annotation: "pose_C",
            frame: 0.1,
            name: "Pumps",
          },
          {
            annotation: "Pump_L_front",
            name: "Transfer pump",
            animations: ["scene"],
            animationSequences: [[12.33, 15]],
            content: {
              Block: Pumps_1,
            },
          },
          {
            annotation: "Pump_C",
            name: "Feed pump",
            animations: ["scene"],
            animationSequences: [[4.5, 9.83]],
            content: {
              Block: Pumps_2,
            },
          },
          {
            annotation: "Pump_R_side",
            name: "Permeate pump",
            animations: ["scene"],
            animationSequences: [[12.33, 15]],
            content: {
              Block: Pumps_3,
            },
          },
        ],
      },
      {
        id: "4-3",
        text: "Sensors",
        title: "Sensors",
        sidebar: { Content: Sensors },
        annotations: ["pose_B"],
        staticFrameWithHotspot: [
          {
            name: "Sensors",
            annotation: "pose_B",
            frame: 4,
          },
        ],
        subHotspots: [
          {
            name: "Sensors",
            annotation: "pose_B",
            frame: 4,
          },
          {
            name: "Conductivity - permeate",
            annotation: "sens_CONDUCT_1",
            frame: 16.66,
            content: {
              Block: ConductivieySub,
              align: "top",
            },
          },
          {
            name: "Conductivity - retentate",
            annotation: "sens_CONDUCT_2",
            frame: 16.66,
          },
          {
            name: "Pressure - permeate",
            annotation: "sens_PRESSURE_1",
            frame: 17.16,
            content: {
              Block: PressureSub,
              align: "top",
            },
          },
          {
            name: "Pressure - feed",
            annotation: "sens_PRESSURE_2",
            frame: 17.16,
          },
          {
            name: "Pressure - retentate",
            annotation: "sens_PRESSURE_3",
            frame: 17.16,
          },
          {
            name: "UV sensor",
            annotation: "sens_UV",
            frame: 17.66,
            content: {
              Block: UvSensorSub,
              align: "top",
            },
          },
          {
            name: "pH sensor",
            annotation: "sens_PH",
            frame: 18.16,
            content: {
              Block: PhSensorSub,
              align: "top",
            },
          },
          {
            name: "Flow meter",
            annotation: "sens_FLOW",
            frame: 18.66,
            content: {
              Block: FlowMeterSub,
              align: "top",
            },
          },
        ],
      },
    ],
  },
];
